import ElCol from './src/col';

/* istanbul ignore next */
ElCol.install = function(Vue) {
  Vue.component(ElCol.name, ElCol);
};

export default ElCol;




// WEBPACK FOOTER //
// ./src/components/element/packages/col/index.js